module.exports = __webpack_public_path__ + "24784ee6248b820235f1caae96627356.png";